export enum PaymentStatus {
  PAID = 'paid',
  UNPAID = 'unpaid',
  FAILED = 'failed'
}
